var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"filterable":true,"options":_vm.items,"custom-label":_vm.label,"placeholder":'Select'},on:{"input":_vm.emitSelected},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }